(function () {
  "use strict";

  var ASSEMBLE_VARIANT_ID = 49593336397962;
  var NAME_PLATE_VARIANT_ID = 47834729939082;

  function addCartItem(urls, payload) {
    return fetch(urls.add, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var msg = (data && data.description) || (data && data.message) || "Cart add failed";
          throw new Error(msg);
        }
        return data;
      });
    });
  }

  function getCartUrls() {
    var routes = (window.MinimogSettings && window.MinimogSettings.routes) || {};
    var root = routes.root ? String(routes.root).replace(/\/$/, "") : "";
    var changeBase = routes.cart_change_url || "/cart/change";
    return {
      add: routes.cart_add_url || "/cart/add.js",
      change: changeBase.indexOf(".js") === -1 ? changeBase + ".js" : changeBase,
      cart: root ? root + "/cart.js" : "/cart.js",
    };
  }

  function genPairId() {
    return "as_" + Date.now() + "_" + Math.random().toString(36).slice(2, 11);
  }

  function getAddedItem(ev) {
    if (!ev || !ev.detail || !ev.detail.product) return {};
    var resp = ev.detail.product;
    if (resp.items && resp.items.length > 0) {
      return {
        variantId: resp.items[0].variant_id,
        productId: resp.items[0].product_id,
      };
    }
    return {
      variantId: resp.variant_id,
      productId: resp.product_id,
    };
  }

  function getProductTitle(item) {
    return (item && (item.product_title || item.title)) || "";
  }

  function findAssembleServiceLine(cart, line, item) {
    var pairId = item.properties && item.properties["_assemble_pair_id"];

    if (pairId) {
      for (var i = 0; i < cart.items.length; i++) {
        if (i === line - 1) continue;
        var other = cart.items[i];
        if (!isAssembleServiceItem(other)) continue;
        var otherPairId = other.properties && other.properties["_assemble_pair_id"];
        if (otherPairId === pairId) return i + 1;
      }
    }

    var productTitle = getProductTitle(item);
    if (!productTitle) return null;

    for (var j = 0; j < cart.items.length; j++) {
      if (j === line - 1) continue;
      var candidate = cart.items[j];
      if (!isAssembleServiceItem(candidate)) continue;
      var forProduct = candidate.properties && candidate.properties["For product"];
      if (forProduct === productTitle) return j + 1;
    }

    return null;
  }

  function findCarLineForAssemble(cart, line, item) {
    var pairId = item.properties && item.properties["_assemble_pair_id"];

    if (pairId) {
      for (var i = 0; i < cart.items.length; i++) {
        if (i === line - 1) continue;
        var other = cart.items[i];
        if (isAssembleServiceItem(other)) continue;
        var otherPairId = other.properties && other.properties["_assemble_pair_id"];
        if (otherPairId === pairId) return i + 1;
      }
    }

    var forProduct = item.properties && item.properties["For product"];
    if (!forProduct) return null;

    for (var j = 0; j < cart.items.length; j++) {
      if (j === line - 1) continue;
      var candidate = cart.items[j];
      if (isAssembleServiceItem(candidate)) continue;
      if (getProductTitle(candidate) === forProduct) return j + 1;
    }

    return null;
  }

  function findPairLine(cart, line, item) {
    if (isAssembleServiceItem(item)) {
      return findCarLineForAssemble(cart, line, item);
    }
    return findAssembleServiceLine(cart, line, item);
  }

  function stripAssembleProps(properties) {
    var next = {};
    if (!properties) return next;
    Object.keys(properties).forEach(function (key) {
      if (key === "Assembly" || key === "_assemble_pair_id") return;
      next[key] = properties[key];
    });
    return next;
  }

  function isAssembleServiceItem(item) {
    return item && String(item.variant_id) === String(ASSEMBLE_VARIANT_ID);
  }

  function hasAssemblePairing(item) {
    return !!(item && item.properties && item.properties["_assemble_pair_id"]);
  }

  function findNpPairLine(cart, line, item) {
    var pairId = item.properties && item.properties["_np_pair_id"];
    var isPersonalized = item.properties && item.properties["Number Plate Text"];
    var isNamePlate = String(item.variant_id) === String(NAME_PLATE_VARIANT_ID);

    if (pairId) {
      for (var i = 0; i < cart.items.length; i++) {
        if (i === line - 1) continue;
        var other = cart.items[i];
        var otherPairId = other.properties && other.properties["_np_pair_id"];
        if (otherPairId === pairId) return i + 1;
      }
    }

    if (!isPersonalized && !isNamePlate) return null;

    var idx = line - 1;
    var prev = idx > 0 ? cart.items[idx - 1] : null;
    var next = idx < cart.items.length - 1 ? cart.items[idx + 1] : null;

    if (isPersonalized) {
      if (prev && String(prev.variant_id) === String(NAME_PLATE_VARIANT_ID)) return idx;
      if (next && String(next.variant_id) === String(NAME_PLATE_VARIANT_ID)) return idx + 2;
    } else if (isNamePlate) {
      if (prev && prev.properties && prev.properties["Number Plate Text"]) return idx;
      if (next && next.properties && next.properties["Number Plate Text"]) return idx + 2;
    }

    for (var j = 0; j < cart.items.length; j++) {
      if (j === line - 1) continue;
      var candidate = cart.items[j];
      if (isPersonalized && String(candidate.variant_id) === String(NAME_PLATE_VARIANT_ID)) return j + 1;
      if (isNamePlate && candidate.properties && candidate.properties["Number Plate Text"]) return j + 1;
    }

    return null;
  }

  function collectRelatedLines(cart, line, item) {
    var lines = [line];
    var assemblePair = findPairLine(cart, line, item);
    var npPair = findNpPairLine(cart, line, item);
    if (assemblePair && lines.indexOf(assemblePair) === -1) lines.push(assemblePair);
    if (npPair && lines.indexOf(npPair) === -1) lines.push(npPair);

    var expanded = true;
    while (expanded) {
      expanded = false;
      lines.slice().forEach(function (ln) {
        var cartItem = cart.items[ln - 1];
        if (!cartItem) return;
        var extraNp = findNpPairLine(cart, ln, cartItem);
        var extraAssemble = findAssembleServiceLine(cart, ln, cartItem);
        if (extraNp && lines.indexOf(extraNp) === -1) {
          lines.push(extraNp);
          expanded = true;
        }
        if (extraAssemble && lines.indexOf(extraAssemble) === -1) {
          lines.push(extraAssemble);
          expanded = true;
        }
      });
    }

    return lines.sort(function (a, b) {
      return b - a;
    });
  }

  function hasAssembleLink(cart, line, item) {
    if (!item) return false;
    if (isAssembleServiceItem(item) || hasAssemblePairing(item)) return true;
    return !!findAssembleServiceLine(cart, line, item);
  }

  function isAssembleRelated(item) {
    if (!item) return false;
    return hasAssemblePairing(item) || isAssembleServiceItem(item);
  }

  function isNpRelated(item) {
    if (!item) return false;
    return !!(
      (item.properties && item.properties["_np_pair_id"]) ||
      (item.properties && item.properties["Number Plate Text"]) ||
      String(item.variant_id) === String(NAME_PLATE_VARIANT_ID)
    );
  }

  class AssembleServiceOption {
    constructor(container) {
      this.container = container;
      this.sectionId = container.dataset.sectionId;
      this.productTitle = container.dataset.productTitle || "";
      this.checkbox = container.querySelector("[data-assemble-checkbox]");
      this.propPair = document.getElementById("as-prop-pair-" + this.sectionId);
      this.init();
    }

    init() {
      this.bindCheckbox();
      this.setupPairIdOnSubmit();
    }

    bindCheckbox() {
      var self = this;
      if (!this.checkbox) return;

      this.checkbox.addEventListener("change", function () {
        var checked = self.checkbox.checked;
        if (!checked && self.propPair) {
          self.propPair.value = "";
          self.propPair.disabled = true;
        }
      });
    }

    setupPairIdOnSubmit() {
      var self = this;
      var section =
        this.container.closest("product-info") ||
        document.querySelector("product-info");
      if (!section) return;

      var form = section.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return;

      form.addEventListener(
        "submit",
        function () {
          if (!self.checkbox || !self.checkbox.checked) {
            return;
          }

          var pairId = genPairId();
          if (self.propPair) {
            self.propPair.value = pairId;
            self.propPair.disabled = false;
          }
        },
        true
      );
    }
  }

  function getAddedLineItem(ev) {
    if (!ev || !ev.detail || !ev.detail.product) return null;
    var resp = ev.detail.product;
    if (resp.items && resp.items.length > 0) return resp.items[0];
    if (resp.variant_id) return resp;
    return null;
  }

  function readLabelFromRadio(radio) {
    if (!radio) return null;
    var sw = radio.nextElementSibling;
    return sw && sw.dataset.color ? sw.dataset.color : radio.value;
  }

  function readPendingAddonsFromDom(addedLineItem) {
    var pendingNp = null;
    var pendingAssemble = null;
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    var qtyInput = form && form.querySelector('input[name="quantity"]');
    var qty = (qtyInput && parseInt(qtyInput.value, 10)) || 1;
    var addedProps = (addedLineItem && addedLineItem.properties) || {};

    var npEl = document.querySelector(".np-personalizer");
    if (npEl && npEl.dataset.isNamePlateProduct !== "true") {
      var npSid = npEl.dataset.sectionId;
      var textInput = document.getElementById("np-text-" + npSid);
      var text = "";
      if (textInput) {
        text = textInput.value.replace(/[^A-Za-z0-9 ]/g, "").toUpperCase().trim();
      }
      if (text) {
        var npPairInput = document.getElementById("np-prop-pair-" + npSid);
        var npPairId =
          (npPairInput && npPairInput.value) ||
          addedProps._np_pair_id ||
          document._npLastPairId ||
          genPairId();

        pendingNp = {
          pairId: npPairId,
          qty: qty,
          text: text,
          bgLabel:
            readLabelFromRadio(npEl.querySelector('input[name="np-bg-' + npSid + '"]:checked')) || "White",
          tcLabel:
            readLabelFromRadio(npEl.querySelector('input[name="np-tc-' + npSid + '"]:checked')) || "Black",
          borderLabel:
            readLabelFromRadio(npEl.querySelector('input[name="np-bd-' + npSid + '"]:checked')) || "Black",
        };
      }
    }

    var asEl = document.querySelector(".assemble-service");
    if (asEl) {
      var checkbox = asEl.querySelector("[data-assemble-checkbox]");
      if (checkbox && checkbox.checked) {
        var asSid = asEl.dataset.sectionId;
        var asPairInput = document.getElementById("as-prop-pair-" + asSid);
        var asPairId =
          (asPairInput && asPairInput.value) || addedProps._assemble_pair_id || genPairId();

        pendingAssemble = {
          pairId: asPairId,
          qty: qty,
          productTitle: asEl.dataset.productTitle || "",
        };
      }
    }

    return { pendingNp: pendingNp, pendingAssemble: pendingAssemble };
  }

  function setupFormSubmitCapture() {
    if (document._addonFormSubmitBound) return;
    document._addonFormSubmitBound = true;

    document.addEventListener(
      "submit",
      function (e) {
        var form = e.target;
        if (!form || form.getAttribute("data-type") !== "add-to-cart-form") return;

        var captured = readPendingAddonsFromDom(null);

        if (captured.pendingNp && !captured.pendingNp.pairId) {
          captured.pendingNp.pairId = genPairId();
        }
        if (captured.pendingAssemble && !captured.pendingAssemble.pairId) {
          captured.pendingAssemble.pairId = genPairId();
        }

        document._pendingNamePlateAddon = captured.pendingNp;
        document._pendingAssembleAddon = captured.pendingAssemble;

        var npEl = document.querySelector(".np-personalizer");
        if (npEl && captured.pendingNp) {
          var npSid = npEl.dataset.sectionId;
          var npPairInput = document.getElementById("np-prop-pair-" + npSid);
          if (npPairInput) {
            npPairInput.value = captured.pendingNp.pairId;
            npPairInput.disabled = false;
          }
          document._npLastPairId = captured.pendingNp.pairId;

          var propText = document.getElementById("np-prop-text-" + npSid);
          var propBg = document.getElementById("np-prop-bg-" + npSid);
          var propTc = document.getElementById("np-prop-tc-" + npSid);
          var propBd = document.getElementById("np-prop-bd-" + npSid);
          if (propText) {
            propText.value = captured.pendingNp.text;
            propText.disabled = false;
          }
          if (propBg) {
            propBg.value = captured.pendingNp.bgLabel;
            propBg.disabled = false;
          }
          if (propTc) {
            propTc.value = captured.pendingNp.tcLabel;
            propTc.disabled = false;
          }
          if (propBd) {
            propBd.value = captured.pendingNp.borderLabel;
            propBd.disabled = false;
          }
        }

        var asEl = document.querySelector(".assemble-service");
        if (asEl && captured.pendingAssemble) {
          var asSid = asEl.dataset.sectionId;
          var asPairInput = document.getElementById("as-prop-pair-" + asSid);
          if (asPairInput) {
            asPairInput.value = captured.pendingAssemble.pairId;
            asPairInput.disabled = false;
          }
        }
      },
      true
    );
  }

  function addVariantToCart(urls, payload) {
    return fetch(urls.add, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var msg = (data && data.description) || (data && data.message) || "Cart add failed";
          throw new Error(msg);
        }
        return data;
      });
    });
  }

  function setupAddonCoordinator() {
    if (document._addonCoordinatorBound) return;
    document._addonCoordinatorBound = true;

    document.addEventListener("product-ajax:added", function (ev) {
      var addedLine = getAddedLineItem(ev);
      var fromDom = readPendingAddonsFromDom(addedLine);
      var pendingNp = fromDom.pendingNp || document._pendingNamePlateAddon;
      var pendingAssemble = fromDom.pendingAssemble || document._pendingAssembleAddon;
      document._pendingNamePlateAddon = null;
      document._pendingAssembleAddon = null;

      if (!pendingNp && !pendingAssemble) return;

      var added = getAddedItem(ev);
      if (
        added.variantId &&
        (String(added.variantId) === String(ASSEMBLE_VARIANT_ID) ||
          String(added.variantId) === String(NAME_PLATE_VARIANT_ID))
      ) {
        return;
      }

      var urls = getCartUrls();
      var items = [];

      if (pendingNp && pendingNp.text) {
        var npProps = {
          "Number Plate Text": pendingNp.text,
          "Plate Background Color": pendingNp.bgLabel || "White",
          "Plate Text Color": pendingNp.tcLabel || "Black",
          "Plate Border Color": pendingNp.borderLabel || "Black",
        };
        if (pendingNp.pairId) npProps._np_pair_id = pendingNp.pairId;

        items.push({
          id: NAME_PLATE_VARIANT_ID,
          quantity: pendingNp.qty || 1,
          properties: npProps,
        });
      }

      if (pendingAssemble) {
        var asProps = { Assembly: "Yes (Auckland)" };
        if (pendingAssemble.pairId) asProps._assemble_pair_id = pendingAssemble.pairId;
        if (pendingAssemble.productTitle) asProps["For product"] = pendingAssemble.productTitle;

        items.push({
          id: ASSEMBLE_VARIANT_ID,
          quantity: pendingAssemble.qty || 1,
          properties: asProps,
        });
      }

      if (items.length === 0) return;

      var payload = items.length === 1 ? items[0] : { items: items };

      addVariantToCart(urls, payload)
        .then(function () {
          document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        })
        .catch(function (err) {
          console.error("[CartAddons] Failed to add addons:", err);
        });
    });
  }

  function setupAutoAddVariant() {
    setupFormSubmitCapture();
    setupAddonCoordinator();
  }

  function setupRemovePairing() {
      if (document._assembleRemoveBound) return;
      document._assembleRemoveBound = true;

      var urls = getCartUrls();

      document.addEventListener(
        "click",
        function (e) {
          var btn = e.target.closest("m-cart-remove-button");
          if (!btn) return;

          var line = parseInt(btn.dataset.index || "0", 10);
          if (!line) return;

          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          var cartItemsEl = btn.closest("m-cart-items") || document.querySelector("m-cart-items");

          fetch(urls.cart)
            .then(function (r) {
              if (!r.ok) throw new Error("Cart fetch failed");
              return r.json();
            })
            .then(function (cart) {
              var item = cart.items[line - 1];
              if (!item) {
                if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
                return;
              }

              if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.start();

              var isAssembleService = isAssembleServiceItem(item);
              var pairLine = findPairLine(cart, line, item);

              function doRemove(lineNum) {
                return fetch(urls.change, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: JSON.stringify({ line: lineNum, quantity: 0 }),
                }).then(function (r) {
                  return r.json().then(function (data) {
                    if (!r.ok || (data && data.errors)) {
                      throw new Error((data && data.description) || (data && data.message) || "Cart update failed");
                    }
                    return data;
                  });
                });
              }

              function doUpdateProperties(lineNum, quantity, properties) {
                return fetch(urls.change, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: JSON.stringify({
                    line: lineNum,
                    quantity: quantity,
                    properties: properties,
                  }),
                }).then(function (r) {
                  return r.json().then(function (data) {
                    if (!r.ok || (data && data.errors)) {
                      throw new Error((data && data.description) || (data && data.message) || "Cart update failed");
                    }
                    return data;
                  });
                });
              }

              function refreshCart() {
                if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
                document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
              }

              if (isAssembleService && pairLine) {
                var carItem = cart.items[pairLine - 1];
                var cleanedProps = stripAssembleProps(carItem.properties);
                return doUpdateProperties(pairLine, carItem.quantity, cleanedProps)
                  .then(function () {
                    return doRemove(line);
                  })
                  .then(refreshCart);
              }

              if (isAssembleService) {
                return doRemove(line).then(refreshCart);
              }

              var linesToRemove = collectRelatedLines(cart, line, item);

              var chain = Promise.resolve();
              linesToRemove.forEach(function (lineNum, index) {
                chain = chain.then(function () {
                  if (index > 0) {
                    return new Promise(function (resolve) {
                      setTimeout(resolve, 300);
                    });
                  }
                }).then(function () {
                  return doRemove(lineNum);
                });
              });

              return chain.then(refreshCart);
            })
            .catch(function (err) {
              console.warn("[Assemble] Remove failed:", err);
              if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
            });
        },
        true
      );
  }

  function setupQuantitySync() {
      if (document._assembleQtySyncBound) return;
      document._assembleQtySyncBound = true;

      var urls = getCartUrls();

      document.addEventListener(
        "change",
        function (e) {
          var input = e.target;
          if (input.type !== "number" || !input.dataset.index) return;
          if (!input.closest("m-cart-items") && !input.closest("m-cart")) return;

          var line = parseInt(input.dataset.index || "0", 10);
          var qty = parseInt(input.value, 10);
          if (!line || isNaN(qty) || qty < 0) return;

          var cartItemsEl = document.querySelector("m-cart-items");
          if (!cartItemsEl) return;

          fetch(urls.cart)
            .then(function (r) {
              if (!r.ok) throw new Error("Cart fetch failed");
              return r.json();
            })
            .then(function (cart) {
              var item = cart.items[line - 1];
              if (!item) return;

              if (isAssembleServiceItem(item)) return;

              var hasAssemble = hasAssembleLink(cart, line, item);
              var hasNp = isNpRelated(item);

              if (!hasAssemble && !hasNp) return;

              e.preventDefault();
              e.stopPropagation();
              if (cartItemsEl.loading) cartItemsEl.loading.start();

              var linesToUpdate = collectRelatedLines(cart, line, item);

              function doChange(lineNum, quantity) {
                return fetch(urls.change, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: JSON.stringify({ line: lineNum, quantity: quantity }),
                }).then(function (r) {
                  return r.json().then(function (data) {
                    if (!r.ok || (data && data.errors)) {
                      throw new Error((data && data.description) || (data && data.message) || "Cart update failed");
                    }
                    return data;
                  });
                });
              }

              function refreshCart() {
                if (cartItemsEl.loading) cartItemsEl.loading.finish();
                document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
              }

              return Promise.all(
                linesToUpdate.map(function (lineNum) {
                  return doChange(lineNum, qty);
                })
              )
                .then(refreshCart)
                .catch(function (err) {
                  if (cartItemsEl.loading) cartItemsEl.loading.finish();
                  console.warn("[Assemble] Quantity sync failed:", err);
                });
            })
            .catch(function (err) {
              if (cartItemsEl && cartItemsEl.loading) cartItemsEl.loading.finish();
              console.warn("[Assemble] Quantity sync failed:", err);
            });
        },
        true
      );
  }

  function init() {
    setupAutoAddVariant();
    setupRemovePairing();
    setupQuantitySync();

    document.querySelectorAll(".assemble-service").forEach(function (el) {
      if (!el._assembleInit) {
        el._assembleInit = true;
        new AssembleServiceOption(el);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
